module.exports = __webpack_public_path__ + "media/images/e-bilet/Hero_Image_Kyiv-c65e7a39bf6fe55cdc51297a9c646104.webp";